
import React,{useContext,useCallback} from 'react'
import { Grid,Form } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import InputField from "../../../commonComponents/formComponents/inputField";
import {updateEidrEoriNumber} from '../../actions/ShipmentHeaderAction'
import { useEvent } from '../../hooks/useEvent'
import { GET_FORM_CDS } from '../../api/apiEvents'
import { validation } from '../../util/cdsFieldPatterns';
import {addPartiesTabWarnings,deletePartiesTabWarnings} from "../../actions/errorValidationActions";





function EidrEori() {
 
   const dispatch = useDispatch()
   const { isLoading,saveForm }=useEvent("header",true)

   const eidrEoriNumber = useSelector((state)=>state.Shipment.eidrEoriNumber)
   const {declarationCat = ''} = useSelector((state) => state.Shipment) || []

   const getValidationError = React.useMemo(
    () => validation(declarationCat, 'partiesTab'),
    [declarationCat]
  )
  const addErrors = (level, value, fieldName) => {
    dispatch(addPartiesTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deletePartiesTabWarnings(level, value, fieldName))
  }

   const saveEidrEoriNumber = async(params) =>{
    const response = await saveForm({...params})
  
   }

  return (
    <Form.Group className='float-container'  >
    <Grid className='kn__grid mg-bottom' >
       <Grid.Row>
        <Grid.Column className='divFormFeild border-bottom b-brr-5  b-blr-5'>
          <InputField
            isLabel={false}
            id={`eidrEoriNumber`}
            type='text'
            label='EIDR EORI NUMBER'
            boxNumber='3/41'
            className='b-rw-0'
            value={eidrEoriNumber || ''}
            errors={getValidationError("eidrEoriNumber",eidrEoriNumber)}
            clearInput={false}
            onChange={(value) => dispatch(updateEidrEoriNumber({ eidrEoriNumber: value }))}
            onBlur={(value) =>
              {saveEidrEoriNumber({ eidrEoriNumber: eidrEoriNumber || " "})
              let err = getValidationError('eidrEoriNumber', eidrEoriNumber,'partiesTab')
                err.length
                  ? addErrors('partiesTab', err[0], 'eidrEoriNumber')
                  : deleteErrors('partiesTab', '', 'eidrEoriNumber')
            }}
            disabled={false}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
    </Form.Group>
  )
}

export default EidrEori